import { ProjectTypename } from "shared/types/Project"

import { useAttachmentsQuery } from "entities/attachments/api/useAttachmentsQuery"
import { useProjectAttachmentCategoriesQuery } from "entities/attachments/graphql/project-attachments.queries.generated"

import { AggregatedProjectAttachmentData } from "../types/ProjectAttachment"

interface UseProjectAttachmentsDataArgs {
  projectID: string
  options?: { skip?: boolean }
}

export function useProjectAttachmentsData({
  projectID,
  options
}: UseProjectAttachmentsDataArgs): AggregatedProjectAttachmentData {
  const {
    data,
    loading: isLoading,
    error: attachmentsError
  } = useAttachmentsQuery({
    id: projectID,
    resourceType: ProjectTypename,
    skip: options?.skip
  })
  const {
    data: categoriesData,
    loading: isLoadingCategories,
    error: categoriesError
  } = useProjectAttachmentCategoriesQuery({ skip: options?.skip })

  return {
    attachments: {
      data: data?.attachments,
      isLoading,
      isUpdating: !!data?.attachments && isLoading,
      error: !!attachmentsError
    },
    attachmentCategories: {
      data: categoriesData?.projectAttachmentCategories.categories,
      isLoading: isLoadingCategories,
      isUpdating:
        !!categoriesData?.projectAttachmentCategories.categories &&
        isLoadingCategories,
      error: !!categoriesError
    }
  }
}
